import { render } from "./MasterIcon.vue?vue&type=template&id=213552d5"
import script from "./MasterIcon.vue?vue&type=script&lang=js"
export * from "./MasterIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__